import { render, staticRenderFns } from "./PaymentLinkTabModal.vue?vue&type=template&id=224278cf&scoped=true&"
import script from "./PaymentLinkTabModal.vue?vue&type=script&lang=js&"
export * from "./PaymentLinkTabModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLinkTabModal.vue?vue&type=style&index=0&id=224278cf&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224278cf",
  null
  
)

export default component.exports